import React from "react";
import { Helmet } from "react-helmet";

const Head: React.FunctionComponent = () => {
  return <Helmet />;
};

export { Head };
